export const BASE_URL = process.env.BASE_URL ||  'https://be-shvil-yehuda.com/api' ; //'http://localhost:8000/api'   ; //
export const UPLOAD_URL = `${BASE_URL}/upload`;
export const RESOURCES_URL = 'https://resources.be-shvil-yehuda.com/';